module.exports = __webpack_public_path__ + "img/20250827_Laurenz-24.4ce7bb60.jpg";